import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import useStyles from './styles/PlayerStyle'
class VoltaxPlayer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      mediaId: null
    }
  }

  play(mediaId) {
    const vplayer = this.getPlayer()
    if (vplayer) {
      if (mediaId && !this.props.isLoadingNewVideo) {
        this.props.setIsLoadingNewVideo(true)
        vplayer.playNewVideo(mediaId)
      } else {
        vplayer.play()
      }
    }
  }

  pause() {
    const vplayer = this.getPlayer()
    if (vplayer) {
      vplayer.pause()
    }
  }


  getPlayer() {
    if (window.voltax) {
      const vplayers = window.voltax.getAllPlayersOnPage()
      return vplayers[0];
    }
  }

  loadPlayerScript() {
    const script = document.createElement("script");
    script.src = `https://vms-players.minutemediaservices.com/${this.props.playerId}.js`;
    script.setAttribute("data-content-id", this.props.playlistId)
    script.async = true;

    script.addEventListener("load", () => {
      const vplayer = this.getPlayer()

      vplayer.on('play', () => {
        const vplayer = this.getPlayer()
        const currentVideoItem = vplayer.getCurrentVideoItem()
        const mediaId = currentVideoItem.mediaId
        this.props.setIsLoadingNewVideo(false)
        this.props.setIsPlaying(true, mediaId)
      })

      vplayer.on('pause', () => {
        this.props.setIsPlaying(false)
      })
    }, false);

    this.container.appendChild(script)
  }

  componentDidMount() {
    this.loadPlayerScript()
  }

  render() {
    const classes = this.props.classes;
    return <Grid className={classes.voltaxPlayerContainer} ref={el => (this.container = el)} />
  }
}

export default withStyles(useStyles)(VoltaxPlayer)
